module.exports = __webpack_public_path__ + "why10.png?e394f12620bd33c6907c0d3f201a12cf";